import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Container,
  Grid,
  Col,
  Panel,
  Form,
  Button,
  ButtonToolbar,
  Schema,
  Loader,
} from 'rsuite';
import { Unvisible, Visible } from '@rsuite/icons';
import styled from 'styled-components';
import history from '~/services/history';
import { logarRequesicao } from '~/store/modulos/autenticacao/actions';

const { StringType } = Schema.Types;

const SenhaComOlho = styled.div`
  position: relative;
  width: 100%;

  .rs-input {
    padding-right: 40px !important;
  }

  button {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #575757;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const model = Schema.Model({
  email: StringType().isEmail('Email inválido').isRequired('Campo obrigatório'),
  senha: StringType().isRequired('Campo obrigatório'),
});

function Login() {
  const dispatch = useDispatch();
  const [camposInput, setCamposInput] = useState({ email: null, senha: null });
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const carregando = useSelector((state) => state.autenticacao.carregando);

  function alternarVisibilidade() {
    setSenhaVisivel(!senhaVisivel);
  }

  function logarUsuario() {
    const { email, senha } = camposInput;
    dispatch(logarRequesicao(email, senha));
  }

  return (
    <div className="show-fake-browser login-page">
      <Container>
        <Grid>
          <Col mdOffset={6} md={12}>
            <Panel header={<h3>Login</h3>} bordered>
              <Form
                fluid
                model={model}
                onChange={setCamposInput}
                onSubmit={(semErro) => semErro && logarUsuario()}
              >
                <Form.Group>
                  <Form.ControlLabel>Email</Form.ControlLabel>
                  <Form.Control name="email" />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel>Password</Form.ControlLabel>
                  <SenhaComOlho>
                    <Form.Control
                      name="senha"
                      type={senhaVisivel ? 'text' : 'password'}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      onClick={() => alternarVisibilidade()}
                      aria-label={senhaVisivel ? 'Ocultar senha' : 'Mostrar senha'}
                    >
                      {senhaVisivel ? <Unvisible /> : <Visible />}
                    </button>
                  </SenhaComOlho>
                </Form.Group>
                <ButtonToolbar>
                  <Button appearance="primary" type="submit" block>
                    Entrar
                  </Button>
                  <Button
                    appearance="link"
                    type="button"
                    block
                    onClick={() => history.push('/esqueci-senha')}
                  >
                    Esqueci minha senha
                  </Button>
                </ButtonToolbar>
                {carregando && (
                  <Loader backdrop content="loading..." vertical />
                )}
              </Form>
            </Panel>
          </Col>
        </Grid>
      </Container>
    </div>
  );
}

export default Login;
